import { setLanguageSwitch, switchLanguage } from 'actions';
import { supportedLanguages } from 'app/modules/CompanyManagement/Factories/AddEditFactory/components/utils/constant';
import {
    apiRequest,
    handlePromiseError,
} from 'app/modules/shared/api/apiRequest';
import { LanguageSwitcherAPI } from 'app/modules/shared/components/Header/LanguageSwitcher/LanguageSwitcherAPI';
import { useAuthuser } from 'app/modules/shared/hooks/useAuthuser';
import getTranslation from 'app/modules/shared/util/Language';
import showNotificationMessage from 'app/modules/shared/util/NotificationMessage';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { RootStore } from 'store/store.types';
import {
    initialLangState,
    updateDocumentDirection,
    updateUserAndStorage,
} from './helper';
import { LanguageValues, UseLanguageChange } from './useLanguageChange.types';
export const useLanguageChange: UseLanguageChange = () => {
    const { company, factory, _id } = useAuthuser();
    const dispatch = useDispatch<Dispatch>();
    const selectedLanguage = useSelector(
        (state: RootStore) =>
            (state.settings.locale?.value as LanguageValues) ||
            initialLangState(),
    );

    const setSelectedLanguage = useCallback(
        (newValue: LanguageValues) => {
            const newLang = supportedLanguages.find(
                (language) => language.value === newValue,
            );
            if (!newLang) return;
            dispatch(setLanguageSwitch(true));
            const sysLang =
                newValue.toLocaleLowerCase() as Lowercase<LanguageValues>;
            apiRequest(
                LanguageSwitcherAPI.switchLanguage,
                company,
                factory,
                _id,
                sysLang,
            )
                .then(({ data }) => {
                    dispatch(switchLanguage(newLang));
                    updateUserAndStorage({ newLang, dispatch, data });
                    updateDocumentDirection({ newLang });
                    showNotificationMessage(
                        'success',
                        getTranslation(
                            'shared.systemLanguage.updateSuccessfully',
                        ),
                    );
                })
                .catch(handlePromiseError)
                .finally(() => {
                    dispatch(setLanguageSwitch(false));
                });
        },
        [dispatch, company, factory, _id],
    );

    return [selectedLanguage, setSelectedLanguage];
};
